import { ReactNode } from 'react';
import { CustomTooltip } from '../atoms';
import { useAppSelector } from '../../hooks/hooksRedux';
import { RootState } from '../../store';
import { defaultColors } from '../../styles/style-guide';

interface Props {
  label: string;
  tooltip?: string;
  labelPosition?: 'top' | 'right';
  children: ReactNode;
}
const InputGroup = ({ children, tooltip, label, labelPosition = 'top' }: Props) => {
  const { colors } = useAppSelector((state: RootState) => state.styleGuide.data);
  const primaryColors = colors.primary || defaultColors.primary;

  return (
    <div className={`flex ${labelPosition === 'top' ? 'flex-col' : 'flex-row'} items-start justify-start gap-2 pt-2`}>
      <div className="flex gap-2">
        <label style={{ color: primaryColors }} className="text-sm">
          {label}
        </label>
        {tooltip && <CustomTooltip content={tooltip} />}
      </div>
      {children}
    </div>
  );
};

export { InputGroup };
